import type { BlockDef } from '../../prop-types.ts'
import { EMPTY_TEXT } from '../../text.ts'

export const gallery: BlockDef = {
  type: 'gallery',
  v: 1,
  label: { en: 'Gallery', ar: 'معرض الصور' },
  scope: 'page',
  description: 'A grid of pictures, each with its own alternative text. Reflows to one or two columns on a phone.',
  whenToUse: 'The menu photographs, the portfolio, the rooms, the before-and-after.',
  whenNotToUse: 'For one picture — use an Image block. For people with names and roles — use a Team block.',
  variants: [
    { value: 'grid', label: { en: 'Grid', ar: 'شبكة' } },
    { value: 'masonry', label: { en: 'Staggered', ar: 'متدرّج' } },
  ],
  fields: [
    {
      key: 'items',
      label: { en: 'Pictures', ar: 'الصور' },
      // ⚠️ TWENTY-FOUR IS A PAGE-WEIGHT BUDGET, not a taste. Every item is a full-size image on a
      // published page; a customer who uploads eighty holiday photographs has built a site that
      // takes a minute to open on a Saudi mobile connection, and the first person to find out is a
      // paying customer's customer.
      type: {
        kind: 'list',
        max: 24,
        item: [
          {
            key: 'image',
            label: { en: 'Image', ar: 'الصورة' },
            type: { kind: 'image' },
            default: { status: 'placeholder', description: EMPTY_TEXT, orientation: 'square' },
          },
          { key: 'caption', label: { en: 'Caption', ar: 'التعليق' }, type: { kind: 'text' }, default: EMPTY_TEXT },
        ],
      },
      default: [],
      requiredForPublish: true,
    },
    { key: 'columns', label: { en: 'Columns', ar: 'الأعمدة' }, type: { kind: 'number', min: 2, max: 4 }, scope: 'tmpl', default: 3 },
  ],
}
